import { apiSlice } from "../../../app/api/apiSlice";

export const sqlApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    subscribeData: builder.mutation({
      query: ({ users, subject, repeats, at, on, include, format ,cronTime,username}) => ({
        url: '/schedule-screenshot-email',
        method: 'POST',
        body: { 
          cronTime: cronTime,  
          username: username,
          token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJVc2VySW5mZm8I6eyJ1c2VybmFtZSI6Im1vaGl0MTIzIiwicm9sZXMiOlsiRXhwbG9yZXIiXX0sImlhdCI6MTcyMzU0MTE3MiwiZXhwIjoxNzIzNTc3MTcyfQ.B_E5-RWhyU_9s5452xHZ4egHYOWSdd4atOCT5HWncGg",  
          recipients: users,  
          subject: subject,  
          text: "Here is the screenshot you requested.",  
          targetUrl: "http://localhost:3000/home/viewworkbook/66bae08781ee0612a9cf9d72",  
          format: format || "image", 
          repeat: repeats,
          at: at,
          on: on,
          include: include
        },
      }),
    }),
    searchAll: builder.query({
      query: (data) => ({
        url: '/search/all',
        method: 'GET',
        params: {
          query: data,
        },
      }),
    }),
  }),
});

export const { useSubscribeDataMutation, useSearchAllQuery } = sqlApiSlice;
